import React from "react";
import { ICheckboxProps } from "../../../interfaces/Index";
import "./Checkbox.scss";

const Checkbox: React.FunctionComponent<ICheckboxProps> = (props) => {
  return (
    <div className="checkbox">
      <label>
        <input
          id={props.id}
          type="checkbox"
          checked={props.isChecked}
          onChange={props.handleCheckboxChange}
          disabled={props.disabled}
        />
        <span className="checkbox-label">{props.label}</span>
      </label>
    </div>
  );
};

Checkbox.defaultProps = {
  disabled: false,
};

export default Checkbox;
